import loadCustomerModule from './modules/Customer.module';
import loadOrdersModule from './modules/Orders.module';
import loadSessionModule from './modules/Session.module';
const loadReturnItemsModule = () => ({
    hasRouter: true,
    modules: [loadSessionModule(), loadCustomerModule(), loadOrdersModule()],
});
export default loadReturnItemsModule;
